import React, { useContext } from 'react';
import * as PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';
import styled from 'styled-components';
import { t } from '../../../../../utils/i18next';

import UpdateInfoIcon from '../../../../assets/icons/update-info.svg';
import PaymentPlanIcon from '../../../../assets/icons/view-paymentplan.svg';
import PaymentPlanIconAlert from '../../../../assets/icons/view-paymentplan-alert.svg';
import PaymentDateIcon from '../../../../assets/icons/view-statements.svg';
import ManageNotificationsIcon from '../../../../assets/icons/manage-notifications.svg';
import PaymentHistoryIcon from '../../../../assets/icons/payment-history.svg';
import SystemButton from '../../../general/SystemButton';
import { storeContext } from '../../../../context';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  img {
    width: ${({ theme }) => theme.spacingInRems(2)};
    height: ${({ theme }) => theme.spacingInRems(2)};
    background-size: 100%;
  }
  .button {
    border-radius: 0.4rem;
    width: auto;
    & > * {
      pointer-events: none;
    }
    .text {
      display: flex;
      align-items: center;
      .icon {
        margin-right: 2rem;
      }
      span {
        text-align: left;
      }
    }
  }
`;

const MenuLinks = observer(({ onClick }) => {
  const {
    translations: { currentLanguage },
    payable,
    router: { history },
    settings
  } = useContext(storeContext);

  const translationBase = 'payables.payable_link_section';
  const onLinkClick = e => {
    switch (e.target.id) {
      case 'previous-payments':
        history.push('/user/history');
        break;
      case 'payment-plan-summary':
        history.push('/user/payment_plan_summary');
        break;
      case 'view-statements':
        history.push('/user/statements');
        break;
      case 'manage-notifications':
        history.push('/user/preferences');
        break;
      case 'update-information':
        history.push('/user/information');
        break;
      default:
        break;
    }
    onClick();
  };

  const paymentsHistorySetting = settings.get('payments_and_bills_history');
  const showBillingStatements = settings.get('enable_billing_statements');
  const showPaymentsHistory =
    paymentsHistorySetting && paymentsHistorySetting.show_payment_history_link;

  const changeInfoSetting = settings.get('change_requests');
  const showUpdateInfo =
    (changeInfoSetting && changeInfoSetting.insurance_change) ||
    (changeInfoSetting && changeInfoSetting.address_change);

  const update_pp_setting = settings.get('pp_update_from_patient');

  const updatePpMethod = update_pp_setting.update_payment_plan_method;
  const planButtonTitle = updatePpMethod
    ? t(`${translationBase}.manage_payment_plan_title`)
    : t(`${translationBase}.payment_plan`);
  return (
    <StyledContainer onClick={onLinkClick}>
      {showPaymentsHistory && (
        <SystemButton
          color="secondary"
          variant="text"
          isIconButton
          aria-label={t(`${translationBase}.previous_payments`)}
          id="previous-payments"
          data-testid="previous-payments"
        >
          <img
            src={PaymentHistoryIcon}
            className="icon"
            alt={t(`${translationBase}.previous_payments`)}
          />
          <span>{t(`${translationBase}.previous_payments`)}</span>
        </SystemButton>
      )}
      {payable.paymentPlan && payable.paymentPlan.id && (
        <SystemButton
          color="secondary"
          variant="text"
          isIconButton
          aria-label={t(`${translationBase}.payment_plan`)}
          id="payment-plan-summary"
          data-testid="payment-plan-summary"
        >
          <img
            src={
              payable.paymentPlan.isDelinquent
                ? PaymentPlanIconAlert
                : PaymentPlanIcon
            }
            width="24"
            height="24"
            className="icon"
            alt={t(`${translationBase}.payment_plan`)}
          />
          <span>{planButtonTitle}</span>
        </SystemButton>
      )}
      {showBillingStatements && (
        <SystemButton
          color="secondary"
          variant="text"
          isIconButton
          aria-label={t(`${translationBase}.billing_statements`)}
          id="view-statements"
          data-testid="view-statements"
        >
          <img
            src={PaymentDateIcon}
            className="icon"
            alt={t(`${translationBase}.billing_statements`)}
          />
          <span>{t(`${translationBase}.billing_statements`)}</span>
        </SystemButton>
      )}
      <SystemButton
        color="secondary"
        variant="text"
        isIconButton
        aria-label={t(`${translationBase}.bills_subscription`)}
        id="manage-notifications"
        data-testid="manage-notifications"
      >
        <img
          src={ManageNotificationsIcon}
          className="icon"
          alt={t(`${translationBase}.bills_subscription`)}
        />
        <span>{t(`${translationBase}.bills_subscription`)}</span>
      </SystemButton>
      {showUpdateInfo && (
        <SystemButton
          color="secondary"
          variant="text"
          isIconButton
          aria-label={t(`${translationBase}.update_information`)}
          id="update-information"
          data-testid="update-information"
        >
          <img
            src={UpdateInfoIcon}
            className="icon"
            alt={t(`${translationBase}.update_information`)}
          />
          <span>{t(`${translationBase}.update_information`)}</span>
        </SystemButton>
      )}
    </StyledContainer>
  );
});

MenuLinks.propTypes = {
  onClick: PropTypes.func
};

export default MenuLinks;
